import { render, staticRenderFns } from "./Tratamiento.vue?vue&type=template&id=07a1f679&scoped=true"
import script from "./Tratamiento.vue?vue&type=script&lang=js"
export * from "./Tratamiento.vue?vue&type=script&lang=js"
import style0 from "./Tratamiento.vue?vue&type=style&index=0&id=07a1f679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a1f679",
  null
  
)

export default component.exports